import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/img/news/news-app.png'


const _hoisted_1 = { class: "ai-share-header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "ai-share-main" }
const _hoisted_4 = { class: "share-heading" }
const _hoisted_5 = { class: "share-meta" }
const _hoisted_6 = ["datetime"]
const _hoisted_7 = {
  key: 0,
  class: "share-state",
  role: "status"
}
const _hoisted_8 = {
  key: 1,
  class: "share-state",
  role: "alert"
}
const _hoisted_9 = {
  key: 2,
  class: "share-state",
  role: "status"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 2,
  class: "share-resources"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 1 }

import { computed, ref, watch } from 'vue'
import dayjs from 'dayjs'
import { useRoute } from 'vue-router'
import useOpenApp from '@/hooks/useOpenApp'
import { getPublicTurnShareApi, PublicChatTurnShareResponse } from '@/api/aiShare'
import { publicResourceUrl, renderAiShareMarkdown } from '@/utils/aiShareMarkdown'
import logoLight from '@/assets/img/logo-text.png'
import logoDark from '@/assets/img/logo-text-dark.png'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
const isDark = computed(() => route.query.theme === 'dark')
const { openApp } = useOpenApp('Envo://ai/')

const share = ref<PublicChatTurnShareResponse>()
const loading = ref(false)
const loadError = ref(false)
const shareId = computed(() => {
  const id = route.query.id
  return Array.isArray(id) ? id[0] : id
})
const messages = computed(() =>
  [...(share.value?.messages || [])].sort((a, b) => a.sortOrder - b.sortOrder),
)
// 公开分享接口不返回标题，使用首条用户问题作为页面标题。
const shareTitle = computed(() => messages.value.find(message => message.role === 'user')?.content)
const shareDate = computed(() => {
  if (!share.value?.createdAt) return ''
  const date = dayjs(share.value.createdAt)
  return date.isValid() ? date.format('YYYY.MM.DD') : ''
})

let requestVersion = 0
const loadShare = async () => {
  const version = ++requestVersion
  share.value = undefined
  loadError.value = false
  loading.value = false
  if (!shareId.value) {
    loadError.value = true
    return
  }

  loading.value = true
  try {
    const response = await getPublicTurnShareApi(shareId.value)
    if (version !== requestVersion) return
    if (response.value?.code === 'SUCCESS' && response.value.result) {
      share.value = response.value.result
    } else {
      loadError.value = true
    }
  } catch {
    if (version === requestVersion) loadError.value = true
  } finally {
    if (version === requestVersion) loading.value = false
  }
}

watch(shareId, loadShare, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ai-share-page", { 'is-dark': isDark.value }])
  }, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("img", {
        src: isDark.value ? _unref(logoDark) : _unref(logoLight),
        alt: "Envo",
        width: "80",
        height: "16"
      }, null, 8, _hoisted_2),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openApp) && _unref(openApp)(...args)))
      }, _toDisplayString(_ctx.$t('打开App')), 1)
    ]),
    _createElementVNode("main", _hoisted_3, [
      _createElementVNode("article", null, [
        _createElementVNode("header", _hoisted_4, [
          _createElementVNode("h1", null, _toDisplayString(shareTitle.value || _ctx.$t('AI 对话分享')), 1),
          _createElementVNode("div", _hoisted_5, [
            (shareDate.value)
              ? (_openBlock(), _createElementBlock("time", {
                  key: 0,
                  datetime: share.value?.createdAt
                }, _toDisplayString(shareDate.value), 9, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('内容由 EnvoAI 生成')), 1)
          ])
        ]),
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('加载中...')), 1))
          : (loadError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('分享内容暂时无法加载，请稍后重试')), 1),
                (shareId.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: loadShare
                    }, _toDisplayString(_ctx.$t('重新加载')), 1))
                  : _createCommentVNode("", true)
              ]))
            : (!messages.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('暂无分享内容')), 1))
              : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
          return (_openBlock(), _createElementBlock("section", {
            key: index,
            class: _normalizeClass(message.role === 'user' ? 'share-question' : 'share-answer')
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'question-bubble': message.role === 'user' })
            }, [
              (message.role === 'user' && message.content)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(message.content), 1))
                : (message.content)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "share-markdown",
                      innerHTML: _unref(renderAiShareMarkdown)(message.content)
                    }, null, 8, _hoisted_11))
                  : _createCommentVNode("", true),
              (message.resources?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...message.resources].sort((a, b) => a.sortOrder - b.sortOrder), (resource, resourceIndex) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: resourceIndex }, [
                        (_unref(publicResourceUrl)(resource.url))
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _unref(publicResourceUrl)(resource.url),
                              target: "_blank",
                              rel: "noopener noreferrer"
                            }, [
                              (resource.resourceType === 'IMAGE')
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _unref(publicResourceUrl)(resource.url),
                                    alt: resource.displayName,
                                    loading: "lazy"
                                  }, null, 8, _hoisted_14))
                                : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(resource.displayName), 1))
                            ], 8, _hoisted_13))
                          : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(resource.displayName), 1))
                      ], 64))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("button", {
      class: "read-in-app",
      type: "button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(openApp) && _unref(openApp)(...args)))
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        width: "19",
        height: "16"
      }, null, -1)),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('打开App')), 1)
    ])
  ], 2))
}
}

})